var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('answer-render',{ref:"answer",attrs:{"config":_vm.config}},[_c('div',{attrs:{"slot":"head"},slot:"head"},[_c('answer-desc-list',{attrs:{"config":_vm.config,"optionKey":"optionName","optionValueKey":"id","answerValidate":_vm.answerValidate}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efd378f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/RadioBoxGroup/RadioBoxGroupAnswer.vue
// module id = null
// module chunks = 